import { getPasswordValidity } from './password';

export default function PasswordRules({ password, confirmPassword }) {
    const validity = getPasswordValidity(password);
    const items = [
        { key: 'length', label: 'Min 8 characters' },
        { key: 'uppercase', label: 'Uppercase letter' },
        { key: 'lowercase', label: 'Lowercase letter' },
        { key: 'number', label: 'Number (0-9)' },
        { key: 'special', label: 'Special character' }
    ];
    if (confirmPassword !== undefined) {
        items.push({
            key: 'match',
            label: 'Same password',
            valid: password.length > 0 && password === confirmPassword
        });
    }

    return (
        <div className="auth-password-rules">
            {items.map(item => {
                const valid = item.valid ?? validity[item.key];
                return (
                    <div key={item.key} className={valid ? 'is-valid' : ''}>
                        <i className={`fa-solid ${valid ? 'fa-circle-check' : 'fa-circle'}`}></i>
                        {item.label}
                    </div>
                );
            })}
        </div>
    );
}
